import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
// custom components
import { CustomSpinner } from "_atoms";
// styling
import { Colors } from '_styles';
import styled from 'styled-components';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectJob, resetMenuContext, openPaxCheckInModal, setPaxLocation, setShowDeleteBookingModal, setShowFlightList, resetFlightContext, setClickedFromLocTab, selectClickedFromLocTab, setChangeLocModal } from '_redux/slices/utils/menu-context';
import {
    paxCheckOut, resetPaxCheckOutFlags, selectPaxCheckOutStatus, unplanTask, updateTask,
    selectUnRejectPaxStatus, resetUnRejectPaxFlags, unRejectPax, selectUpdateTaskStatus, resetUpdateTaskFlags,
    selectDeleteTaskStatus, resetDeleteFlags, setBookingLocation, selectPassengers,
    selectTaskList,
    selectSetBookingLocationStatus,
    resetSetBookingLocationFlags,
    arrivalPaxCheckIn,
    selectArrivalPaxCheckInStatus,
    resetArrivalPaxCheckInFlags,
    toggleCheckInPause,
    selectToggleCheckInPauseStatus,
    resetToggleCheckInPauseFlags,
    selectCheckInPausedBookings,

} from '_redux/slices/timeline/timeline-data';
import { duplicateTask as duplicateTaskAction, selectDuplicateStatus, resetDuplicateTask, duplicateBookingLocally, updateTimelineBooking, selectUpdateStatus, resetUpdateBooking, selectResolvedBookingsByFlight } from '_redux/slices/timeline/timeline-bookings';
import { selectEmployeeList, sendEmployeeNotification, selectSendNotificationStatus, resetSendingNotificationFlags, updateEmployee } from "_redux/slices/timeline/employees";
import { setShowBreakTaskModal, setBreakTaskEmployee, setSelectedBreakTask, setShowAdhocTaskModal, setAdhocTaskEmployee, setSelectedAdhocTask, setViewTask, setSelectedTaskToView, setSelectedTask, setEditModalType, setShowEditTaskModal } from "_redux/slices/timeline/selected-task";
import { selectFirebaseInfo, selectFirebaseUser } from '_redux/slices/main-screen/user';
import { setToast, setShowToast } from "_redux/slices/timeline/timeline-toast";
import { getEmployeeStatusForAppVersion, isPaxCheckedIn } from "_utils/functions";
import { getToken } from '_services/user-service';


// icons
import { MdDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { IoEyeOutline, IoNotificationsOutline } from "react-icons/io5";
import { BiUserCheck } from "react-icons/bi";
import { BiUserX } from "react-icons/bi";
import { MdQrCode2 } from "react-icons/md";
import { HiOutlineDuplicate } from "react-icons/hi";
import { FaCheck, FaCheckDouble } from "react-icons/fa6";
import { AiOutlineStop } from "react-icons/ai";
import { MdPersonOff } from "react-icons/md";
import { RiUserLocationLine } from 'react-icons/ri';
import { MdLocationPin } from 'react-icons/md';
import { FaPause, FaPlay } from "react-icons/fa6";



const StyledParagraph = styled.p`
    cursor: pointer;
    color: ${props => (props.color)};
    font-weight: 500;
    margin-left: 18px;
    margin-top: 12px;
    border-radius: 5px;
    width: 100%;
    font-size: 12px;
    display: flex;
    align-items: center;
`;

const MenuList = styled.div`
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0px 0px 5px 0px lightgray;
    max-width: 150px;
`;

const JobActionMenu = () => {
    // nav
    const history = useHistory();

    //#region redux
    const dispatch = useDispatch();

    const job = useSelector(selectJob);
    const clickedFromLocTab = useSelector(selectClickedFromLocTab);
    const allEmployees = useSelector(selectEmployeeList);
    const dbUser = useSelector(selectFirebaseInfo);                                       // logged in user
    const paxCheckOutStatus = useSelector(selectPaxCheckOutStatus);                       // status of passenger check out
    const unRejectPaxStatus = useSelector(selectUnRejectPaxStatus);                // UnReject passenger Status
    const updateTaskStatus = useSelector(selectUpdateTaskStatus);                // update task Status
    const sendNotificationStatus = useSelector(selectSendNotificationStatus);
    const deleteTaskStatus = useSelector(selectDeleteTaskStatus);
    const duplicateStatus = useSelector(selectDuplicateStatus);
    const updateBookingStatus = useSelector(selectUpdateStatus);
    const setBookingLocationStatus = useSelector(selectSetBookingLocationStatus)
    const arrivalPaxCheckInStatus = useSelector(selectArrivalPaxCheckInStatus);
    const toggleCheckInPauseStatus = useSelector(selectToggleCheckInPauseStatus);
    const checkInPausedBookings = useSelector(selectCheckInPausedBookings);
    const taskList = useSelector(selectTaskList);
    // resolved, not raw: a booking is bound to the row it renders under, which for an
    // overnight arrival is not the row its own date points at (flight-rotation-binding.js)
    const bookingsByFlightDict = useSelector(selectResolvedBookingsByFlight);

    const firebaseUser = useSelector(selectFirebaseUser);

    //#endregion

    //#region local states
    const [hover, setHover] = useState('none');
    const [canUnPlan, setCanUnPlan] = useState(true);                      // holds the value if the task can be unplanned
    const [canEdit, setCanEdit] = useState(true);                          // holds the value if the task can be edited
    const [canView, setCanView] = useState(true);                          // holds the value if the task can be viewed
    const [canCheckIn, setCanCheckIn] = useState(true);                    // holds the value if it is departure flight so the employee can check in
    const [canCheckOut, setCanCheckOut] = useState(false);                 // holds the value if it is departure flight so the employee can check in
    const [canAssign, setCanAssign] = useState(false);                     // holds the value if the task can be assigned to employee with QR scanner
    const [canDuplicate, setCanDuplicate] = useState(false);               // if the job can be duplicated to assign to multiple employees
    const [canDeleteBooking, setCanDeleteBooking] = useState(true);        // holds the value if the booking can be deleted
    const [canUnReject, setCanUnReject] = useState(false);                   // holds the value if the pax is rejected to un reject it
    const [canStartTask, setCanStartTask] = useState(false);                 // holds the value if the task can be started
    const [canCompleteTask, setCanCompleteTask] = useState(false);          // holds the value if the task can be completed
    const [canStopTask, setCanStopTask] = useState(false);                  // holds the value if the task can be stopped
    const [canShowPaxList, setCanShowPaxList] = useState(false);            // holds the value to show passenger list
    const [canSendNotify, setCanSendNotify] = useState(false);              // holds the value if it can send employee notification or not
    const [canNoShow, setCanNoShow] = useState(false);                      // holds the value if the booking can be marked as no show
    const [shouldCloseMenu, setShouldCloseMenu] = useState(false);
    const [canRemoveFromLoc, setCanRemoveFromLoc] = useState(false);
    const [canChangeLoc, setCanChangeLoc] = useState(false);
    const [canAtLoc, setCanAtLoc] = useState(false);
    const [canPauseCheckIn, setCanPauseCheckIn] = useState(false);
    const [isCheckInPaused, setIsCheckInPaused] = useState(false);
    const lastPauseActionRef = useRef(null);
    //#endregion
    //#region useEffect

    useLayoutEffect(() => {
        dispatch(resetSendingNotificationFlags())
        dispatch(resetDeleteFlags());
        dispatch(resetDuplicateTask());
        setCanDuplicate(false);
        dispatch(resetArrivalPaxCheckInFlags());
    }, [])

    useEffect(() => {

        if (job) {
            // if job doesn't have assignedTime parameter (it's a booking in task list) or completed,active can't be unplanned
            if (!job?.assignedTime || job?.completed || job?.active) setCanUnPlan(false);
            else setCanUnPlan(true);

            // if job doesn't have assignedTime parameter (it's a booking in task list) can be assigned with QR code scanner
            if (!job?.assignedTime) setCanAssign(true);
            else setCanAssign(false);

            //if job has combinedBooking parameter (it's a combined booking in task list) or completed,active or cancelled can't be edited
            // if (job?.combinedBooking || job?.combinedRampBooking || job?.completed || job?.active || job?.cancelled || job?.duplicateVersion || job?._id?.includes("-part") || job?.assignedTime) setCanEdit(false);
            // else setCanEdit(true);

            if (job.completed || job.active || job.cancelled || job.duplicateVersion || job._id?.includes("-part") || (!job.assignedTime && job.passengers)) setCanEdit(false);
            else setCanEdit(true);

            // if job is not a break task it can be viewed
            if (job?.isBreakTask || job?.isAdhocTask) setCanView(false);
            else setCanView(true);

            // if the job is not a combined departure or alternative pickup task or a duplicated booking the passenger can check in
            if (job.flightConfirmationDetails?.origin !== dbUser.details.authority || job.combinedBooking == true || job.combinedRampBooking == true || job.isALTPickUp == true || job.duplicateVersion || isPaxCheckedIn(job, true)) setCanCheckIn(false);
            else setCanCheckIn(true);

            // same derivation as the flight pax list row, so the two never disagree
            if (isPaxCheckedIn(job, true)) setCanCheckOut(true);
            else setCanCheckOut(false);

            // if job is task in task list or isALTPickUp or isEstimatedBooking or combinedRampBooking and doesn't have duplicateVersion or combinedBooking and doesn't have duplicateVersion it can't be deleted
            // Client-side duplicates (isClientDuplicate) can always be deleted
            if (job?.assignedTime || (job?.combinedRampBooking && !job?.duplicateVersion && !job?.isClientDuplicate) || (job?.combinedBooking && !job?.duplicateVersion && !job?.isClientDuplicate)) setCanDeleteBooking(false);
            else setCanDeleteBooking(true);

            if (!job?.assignedTime && (job?.originalBookingDoc?.rejectedPax == true || job?.rejectedPax == true)) setCanUnReject(true);
            else setCanUnReject(false);

            // if job has assignedTime (it's a task) and if it is not active, not completed it can be started
            if (job?.assignedTime && !job?.active && !job?.completed && !job.requireUpdates) setCanStartTask(true);
            else setCanStartTask(false);

            // At-Loc: only when task is assigned + confirmed + not yet at-location + not active/stopped/completed/cancelled
            if (
                job?.assignedTime &&
                job?.acknowledged &&
                !job?.isAtLocation &&
                !job?.active &&
                !job?.stopped &&
                !job?.completed &&
                !job?.cancelled &&
                !job?.isBreakTask &&
                !job?.isAdhocTask &&
                ["BFS", "DUB"].includes(dbUser.details.authority)
            ) setCanAtLoc(true);
            else setCanAtLoc(false);

            // if job has assignedTime (it's a task) and if it is active, not completed it can be completed
            if (job?.assignedTime && job?.active && !job?.completed && !job?.stopped) setCanCompleteTask(true);
            else setCanCompleteTask(false);

            // if job has assignedTime (it's a task) and if it is active, not completed it can be stopped
            if (job?.assignedTime && job?.active) setCanStopTask(true);
            else setCanStopTask(false);

            if (job?.assignedTime && job?.active && (job?.combinedRampBooking || job?.combinedBooking)) setCanShowPaxList(true);
            else setCanShowPaxList(false);

            if (job?.assignedTime && !job.completed) setCanSendNotify(true);
            else setCanSendNotify(false);

            if (job?.isBreakTask || job?.isAdhocTask || (job?._id?.includes("-duplicate-") && !job?.isClientDuplicate) || job?.isALTPickUp) setCanDuplicate(false);
            else setCanDuplicate(true);

            // if job is a departure booking (not assigned) and not already marked as no show, it can be marked as no show
            // exclude boarding bookings, combined bookings, and ramp bookings
            if (!job?.assignedTime && job?.flightConfirmationDetails?.origin === dbUser.details.authority && !job?.noShow && !job?.isBreakTask && !job?.isAdhocTask && !job?.combinedBooking && !job?.isBoardingBooking && !job?.combinedRampBooking) {
                setCanNoShow(true);
            } else {
                setCanNoShow(false);
            }

        }

    }, [job]);

    useEffect(() => {
        if (clickedFromLocTab && !job?.isALTPickUp && !job?.isGateRelocation) {
            setCanRemoveFromLoc(true);
        } else {
            setCanRemoveFromLoc(false);
        }
    }, [clickedFromLocTab, job]);

    // JER also moves checked-in pax from the timeline card, not only from the Locations tab.
    // Gated like Check Out: there has to be a current location to move from.
    useEffect(() => {
        if (job?.isALTPickUp || job?.isGateRelocation) setCanChangeLoc(false);
        else if (clickedFromLocTab) setCanChangeLoc(true);
        else setCanChangeLoc(
            dbUser?.details?.authority === 'JER'
            && !job?.isBreakTask && !job?.isAdhocTask
            && !job?.combinedBooking && !job?.combinedRampBooking
            && isPaxCheckedIn(job, true)
        );
    }, [clickedFromLocTab, job]);

    useEffect(() => {
        if (!clickedFromLocTab || job?.isALTPickUp || job?.isGateRelocation || job?.isBreakTask || job?.isAdhocTask) {
            setCanPauseCheckIn(false);
            setIsCheckInPaused(false);
            return;
        }
        const activity = job?.paxPositionInfo?.activity;
        const hasCheckedIn = activity === 'Checked-in'
            || job?.paxPositionHistory?.some(h => h?.activity === 'Checked-in')
            || !!job?.arrivalPaxCheckIn?.time;
        const isTerminalState = activity === 'Picked up' || activity === 'Dropped Off';
        if (hasCheckedIn && !isTerminalState) {
            setCanPauseCheckIn(true);
            const jobId = job?.originalBookingId || job?._id;
            const pausedFromDb = !!job?.checkInPause?.pausedAt;


            // const pausedFromLocal = checkInPausedBookings?.[jobId]?.pausedAt ? true : false;
            // console.log('pausedFromLocal', pausedFromLocal);
            // setIsCheckInPaused(pausedFromDb || pausedFromLocal);
            setIsCheckInPaused(pausedFromDb);

        } else {
            setCanPauseCheckIn(false);
            setIsCheckInPaused(false);
        }
    }, [clickedFromLocTab, job, checkInPausedBookings]);

    useEffect(() => {
        if (toggleCheckInPauseStatus === "succeeded") {
            dispatch(resetToggleCheckInPauseFlags());
            const action = lastPauseActionRef.current;
            dispatch(setToast({
                message: action === 'pause' ? "Check-in time paused" : "Check-in time resumed",
                statusType: "success",
            }));
            dispatch(setShowToast(true));
            lastPauseActionRef.current = null;
            handleCancel();
        } else if (toggleCheckInPauseStatus === "failed") {
            dispatch(resetToggleCheckInPauseFlags());
            dispatch(setToast({
                message: "Failed to update check-in pause",
                statusType: "error",
            }));
            dispatch(setShowToast(true));
            lastPauseActionRef.current = null;
        }
    }, [toggleCheckInPauseStatus]);

    useEffect(() => {

        /*
        let tempBooking = null
        // if job has assignedTime (it's a task) else it is a bookings
        if (job?.assignedTime) {
            tempBooking = { ...job }

            // if it is a departure task and not a combined booking or estimated booking or alternative pick up task or already duplicated 
            if (tempBooking?.flightInformation?.departureAirport === dbUser?.details?.authority && !tempBooking?.isEstimatedBooking && !tempBooking?.isALTPickUp
                && !tempBooking?.combinedBooking && !tempBooking?._id?.includes("-part")
            ) {
                setCanDuplicate(true);
            } else if (tempBooking?.flightInformation?.arrivalAirport === dbUser?.details?.authority && !tempBooking?._id?.includes("-part") && !tempBooking?.combinedRampBooking) {
                setCanDuplicate(true);

            } else setCanDuplicate(false);
        } else {
            // Handle combined/boarding bookings
            if (job?.combinedBooking || job?.isBoardingBooking) {
                // For boarding bookings, check the original passenger (not a duplicate)
                const originalPassenger = job?.passengers?.find(p => !p?.isDuplicate && !p?.partNumber);
                if (originalPassenger) {
                    tempBooking = { ...originalPassenger };
                } else {
                    // No original passenger found, disable duplication
                    setCanDuplicate(false);
                    return;
                }
            } else if (job?.originalBookingDoc && job?.flightBooking) {
                // if job object has originalBookingDoc and flightBooking it's an arrival flight
                tempBooking = { ...job?.originalBookingDoc }
            } else {
                tempBooking = { ...job }
            }

            // if it is an original booking doc, allow duplication
            if (tempBooking.duplicateCount || !tempBooking.duplicateVersion) {
                setCanDuplicate(true);
            }
            else {
                setCanDuplicate(false);
            }

            if (tempBooking?.isEstimatedBooking || tempBooking?.isALTPickUp || (tempBooking?._id && tempBooking?._id?.includes("-part"))) {
                setCanDuplicate(false);
            }

            // arrival booking and already duplicated
            if (tempBooking?.flightConfirmationDetails?.destination === dbUser?.details?.authority && tempBooking?.duplicateCount) {
                setCanDuplicate(false);
            }
        }
        */
        // setCanDuplicate(true);
    }, [])

    // reset on check out passenger status succeeded or failed
    useEffect(() => {
        if (paxCheckOutStatus == "succeeded" || paxCheckOutStatus == "failed") {
            dispatch(resetPaxCheckOutFlags());
            handleCancel();
        }
    }, [paxCheckOutStatus]);

    useEffect(() => {
        if (unRejectPaxStatus == "succeeded") {
            dispatch(resetUnRejectPaxFlags());
            handleCancel();
        }
    }, [unRejectPaxStatus]);

    useEffect(() => {
        if (sendNotificationStatus === "succeeded") {
            dispatch(resetSendingNotificationFlags())
            handleCancel()
        }

    }, [sendNotificationStatus])

    useEffect(() => {
        if (updateTaskStatus == "succeeded") {
            dispatch(resetUpdateTaskFlags());
            handleCancel();
        };

    }, [updateTaskStatus]);

    useEffect(() => {
        if (deleteTaskStatus == "succeeded") {
            dispatch(resetDeleteFlags());
            handleCancel();
        };

    }, [deleteTaskStatus]);

    useEffect(() => {
        if (duplicateStatus === "succeeded") {
            dispatch(setToast({
                message: "Task Duplicated Successfully",
                statusType: "success",
            }));
            dispatch(setShowToast(true));
            dispatch(resetDuplicateTask());
            handleCancel();
        } else if (duplicateStatus === "failed") {
            dispatch(setToast({
                message: "Failed to duplicate task",
                statusType: "error",
            }));
            dispatch(setShowToast(true));
            dispatch(resetDuplicateTask());
        }
    }, [duplicateStatus]);

    // reset on update booking status succeeded or failed (for no show)
    useEffect(() => {
        if (updateBookingStatus === "succeeded") {
            dispatch(resetUpdateBooking());
            handleCancel();
        } else if (updateBookingStatus === "failed") {
            dispatch(setToast({
                message: "Failed to update booking",
                statusType: "error",
            }));
            dispatch(setShowToast(true));
            dispatch(resetUpdateBooking());
        }
    }, [updateBookingStatus]);
    useEffect(() => {
        // Add event listener when the component mounts
        document.addEventListener('click', heardClick);

        // Cleanup the event listener when the component unmounts
        return () => {
            document.removeEventListener('click', heardClick);
        };
    }, []);

    // This useEffect tracks loading status change
    useEffect(() => {
        const isLoading = updateTaskStatus === "loading" || deleteTaskStatus === "loading" || sendNotificationStatus === "loading" || unRejectPaxStatus === "loading" || paxCheckOutStatus === "loading" || duplicateStatus === "loading" || updateBookingStatus === "loading" || toggleCheckInPauseStatus === "loading";

        if (shouldCloseMenu && !isLoading) {
            handleCancel();            //close the menu after complete loading
            setShouldCloseMenu(false); // Reset the flag
        }
    }, [
        shouldCloseMenu,
        updateTaskStatus,
        deleteTaskStatus,
        sendNotificationStatus,
        unRejectPaxStatus,
        paxCheckOutStatus,
        duplicateStatus,
        updateBookingStatus,
    ]);

    useEffect(() => {
        if (setBookingLocationStatus === "succeeded") {
            dispatch(resetSetBookingLocationFlags());
            handleCancel();
        }
    }, [setBookingLocationStatus]);

    //#endregion

    //#region functions


    const heardClick = () => {
        if (hover === 'none') {
            setShouldCloseMenu(true); // Defer cancel until loading ends
        }
    };


    // unplan task in employee list
    const handleUnplanTask = () => {
        // unplan task
        // toast message 
        dispatch(setToast({
            message: "Task unplanned successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));

        console.log('unplanning job:', job);

        // if job has isALTPickUp means it's alternative pick up task and should update task by remove employeeId and assignedTime from the job object
        if (job && job?._id != undefined && (job?.isALTPickUp == true || job?.isGateRelocation == true)) {
            let tempJob = {
                id: job._id,
                assignedTime: null,
                employeeId: null,
                selectALTPickUpPaxStatus: "unplanned",
            }
            if (job?.paxPositionInfo?.activity == "Assigned") {
                const lastDropOff = job?.paxPositionHistory?.find((position) => position?.activity == "Dropped Off");
                if (lastDropOff) {
                    tempJob.paxPositionInfo = {
                        activity: "Dropped Off",
                        locationId: lastDropOff?.locationId,
                        locationName: lastDropOff?.locationName,
                        time: lastDropOff?.time
                    }
                    tempJob.paxPositionHistory = Array.isFullArray(job?.paxPositionHistory)
                        ? [
                            job?.paxPositionInfo,
                            ...job?.paxPositionHistory,
                        ]
                        : [job?.paxPositionInfo];
                }
            }

            console.log('updating task:', tempJob);
            dispatch(updateTask(tempJob));
            handleAgentStatus("online", job.uid ?? job.employeeId)
            handleCancel();

        } else if (job && job['_id'] != undefined) {
            // remove the job from task list
            // const bookingIds = getBookingIdsFromTask(job)
            const params = {
                taskId: job?._id,
                iata: dbUser.details.authority
                // bookingIds
            }
            handleAgentStatus("online", job.uid ?? job.employeeId)
            dispatch(unplanTask(params));

        }
    };


    // edit task
    const handleEditTask = () => {
        // check if selected job to edit is a break task or not
        if (job?.isBreakTask) {
            // get the selected employee
            let tempEmployee = allEmployees?.find((employee) => employee?.employeeId == job?.employeeId)
            // check if tempEmployee is not null and not empty
            if (!Object.isObjectEmpty(tempEmployee)) {
                // select the break task employee
                dispatch(setBreakTaskEmployee(tempEmployee))
                // open break task modal
                dispatch(setShowBreakTaskModal(true))
                // set the selected break task
                dispatch(setSelectedBreakTask(job))
            }
        } else if (job?.isAdhocTask) {
            // get the selected employee
            let tempEmployee = allEmployees?.find((employee) => employee?.employeeId == job?.employeeId)
            // check if tempEmployee is not null and not empty
            if (!Object.isObjectEmpty(tempEmployee)) {
                // select the adhoc task employee
                dispatch(setAdhocTaskEmployee(tempEmployee))
                // open adhoc task modal
                dispatch(setShowAdhocTaskModal(true))
                // set the selected adhoc task
                dispatch(setSelectedAdhocTask(job))
            }
        } else {
            const modalType = job.assignedTime ? "TASK" : "BOOKING"
            dispatch(setEditModalType(modalType))
            dispatch(setShowEditTaskModal(true))
        }
        handleCancel();
    }
    const handleCancel = () => {
        dispatch(resetMenuContext());
        dispatch(resetFlightContext());
    };

    const handleViewTask = () => {
        dispatch(setViewTask(true));
        dispatch(setSelectedTaskToView(job));
        handleCancel();
    };

    // open passenger check in modal
    const handleCheckIn = (e) => {

        if (e.target.innerText == 'Set Passeneger Location') {
            dispatch(setPaxLocation(true))
        }
        dispatch(openPaxCheckInModal(true));

        handleCancel();
    };


    const handleUnRejectPax = () => {
        // if job has originalBookingId then choose the originalBookingId else _id
        let bookingId = job?.originalBookingId ? job?.originalBookingId : job?._id;
        if (bookingId) {
            dispatch(unRejectPax({
                iata: dbUser.details.authority,
                body: {
                    bookingsIDS: [bookingId]
                }
            }));
        };
    }
    const handleScannerClick = () => {
        dispatch(setSelectedTask(job));
        history.push('employee-scan')
        handleCancel();
    };
    const handleShowDeleteBookingModal = () => {
        dispatch(setShowDeleteBookingModal(true));
        handleCancel();
    };
    const getAssignedEmployee = (agentId) => {
        return allEmployees?.find((employee) => {
            return employee?.employeeId === agentId
                || employee?.uid === agentId
                || employee?.userId === agentId
                || employee?._id === agentId;
        });
    };

    const handleAgentStatus = (status, agentId) => {
        const assignedEmployee = getAssignedEmployee(agentId);
        const appVersionNumber = assignedEmployee?.appVersionNumber ?? job?.appVersionNumber;
        const versionedStatus = getEmployeeStatusForAppVersion(status, appVersionNumber);
        if (!versionedStatus) return;

        const payload = {
            userId: agentId,
            body: {
                status: versionedStatus
            }
        }
        dispatch(updateEmployee(payload))
    }

    const handleStartTask = () => {
        // if job has flightBooking(arrivals) and doesn't have startTime it is a arrival task and needs to select passenger
        if ((job?.flightBooking || job?.combinedBooking || job?.combinedRampBooking) && !job?.startTime && !job?.stopped) {
            dispatch(setShowFlightList(true));
            handleCancel();
        } else {
            if (job && job?._id) {
                let tempJob = {
                    id: job._id,
                    active: true,
                    acknowledged: true,
                    acknowledgedTime: job.acknowledgedTime ?? new Date(),
                    startTime: job?.startTime ? job.startTime : new Date(),
                    stopped: false,
                    paxPositionInfo: {
                        locationId: "Transit",
                        locationTitle: "null",
                        activity: "Picked up",
                        time: new Date()
                    },
                }
                dispatch(updateTask(tempJob));
                const currentStatus = job.isBreakTask ? "onBreak" : "busy"
                handleAgentStatus(currentStatus, job.uid ?? job.employeeId)
                let id = job?.originalBookingId ? job?.originalBookingId : job?._id;
                if (id && !id?.includes("-selfAllocatedTask-") && job?.buggyTask !== true && !id?.includes("-part") && !job?.flightBooking && !job.isBreakTask) {
                    const payload = {
                        taskId: id,
                        body: {
                            bookingsIds: [id],
                            taskType: "departure",
                            iata: dbUser.details.authority
                        }

                    };
                    dispatch(selectPassengers(payload));
                    // need to update booking object to add last drop off location
                    let object = {
                        bookingId: id,
                        location: 'Transit',
                        locationTitle: 'null',
                        activity: "Picked up",
                        time: new Date(),
                        checkInFlag: false,
                        setBy: {
                            id: firebaseUser?.uid ?? "",
                            name: firebaseUser?.displayName ?? "",
                            from: "portal",
                            time: new Date(),
                        }
                    }
                    dispatch(setBookingLocation(object));
                }
            }
        };

        // toast message
        dispatch(setToast({
            message: "Task Started Successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    };
    //In case we should not send initial notification for create task during break, add condition selectedEmployee.onBreak

    const handleSendNotification = () => {
        const selectedEmployee = allEmployees?.find((employee) => employee?.employeeId == job?.employeeId)
        if (selectedEmployee && selectedEmployee.FCMTokens) {
            const notification = {
                notificationTitle: "New Assigned Task at " + job?.assignedTime,
                notificationText: `Please collect passenger ${job?.name ? job?.name : ""}`,
                fcmToken: selectedEmployee?.FCMTokens,
                iata: dbUser.details.authority
            };
            dispatch(sendEmployeeNotification(notification));

        }
    }


    const handleShowPaxList = () => {
        dispatch(setShowFlightList(true));
        handleCancel();
    };

    const handleCompleteTask = () => {
        if (job && job?._id) {
            let tempJob = {
                id: job._id,
                active: false,
                completed: true,
                completeTime: new Date(),
                paxPositionInfo: {
                    "activity": 'Dropped Off',
                    "locationId": "",
                    "locationName": "",
                    "time": new Date()
                }
            }
            dispatch(updateTask(tempJob));
            handleAgentStatus("online", job.uid ?? job.employeeId)
        }

        // toast message
        dispatch(setToast({
            message: "Task Completed Successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    };

    const handleAtLoc = () => {
        if (job && job?._id) {
            const now = new Date();
            const tempJob = {
                id: job._id,
                isAtLocation: true,
                atLocationTime: now,
                atLocationInformation: {
                    pressedAt: now.toISOString(),
                    verifiedAt: now.toISOString(),
                    verificationLevel: 'portal',
                    verificationMethod: 'Portal',
                    locationId: job?.pickUpLocation?.id ?? null,
                    locationName: job?.pickUpLocation?.name ?? null,
                    portal: {
                        triggeredBy: firebaseUser?.displayName ?? firebaseUser?.email ?? 'Portal User',
                        triggeredById: firebaseUser?.uid ?? null,
                        triggeredAt: now.toISOString(),
                    },
                },
            };
            dispatch(updateTask(tempJob));
            // handleAgentStatus("available",job.employeeId),//compare it within app side
        }

        dispatch(setToast({
            message: "At Location marked successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    };

    const handleStopTask = () => {
        if (job && job?._id) {
            let tempJob = {
                id: job._id,
                active: false,
                completed: false,
                stopped: true,
                stopTime: new Date(),
                cancelled: false,
            }
            dispatch(updateTask(tempJob));
            handleAgentStatus("online", job.uid ?? job.employeeId)
        }

        // toast message
        dispatch(setToast({
            message: "Task Stopped Successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    };

    const handleNoShow = () => {
        if (job && job?._id) {

            console.log('marking job as no show: ', job);

            const bookingUpdate = {
                id: job._id,
                body: {
                    noShow: true,
                },
            };
            dispatch(updateTimelineBooking(bookingUpdate));

            // toast message
            dispatch(setToast({
                message: "Passenger marked as No Show",
                statusType: "success",
            }));
            dispatch(setShowToast(true));
        }
    };

    const handleDuplicate = () => {
        if (job?.combinedBooking || job?.isBoardingBooking || job?.combinedRampBooking) {
            // Client-side duplication for ramp/boarding bookings
            let flightKey;

            // Extract flight key - ramp tasks store data differently
            if (job?.combinedRampBooking && job?.flightData) {
                // Ramp task uses flightData with different property names
                const fd = job.flightData;
                flightKey = job.flightKey || `${fd.flightNumber}_${fd.origin}_${fd.destination}_${fd.flightDate}`;

            } else if (job?.combinedBooking && job?.combinedMarshallBooking) {
                // Extract flight key - for boarding marshall tasks
                const fd = job.flightData;
                if (!fd) {
                    dispatch(setToast({
                        message: "Cannot duplicate: Missing flight details",
                        statusType: "error",
                    }));
                    dispatch(setShowToast(true));
                    return;
                }
                flightKey = job.flightKey || `${fd.flightNumber}_${fd.origin}_${fd.destination}_${fd.flightDate}_BOARDING`;
            } else {
                // Boarding bookings use flightConfirmationDetails
                const fc = job?.flightConfirmationDetails || job?.flightDetails;
                const taskFc = job?.flightInformation;
                if (!fc && !taskFc) {
                    dispatch(setToast({
                        message: "Cannot duplicate: Missing flight details",
                        statusType: "error",
                    }));
                    dispatch(setShowToast(true));
                    return;
                }

                // Construct flight key with _BOARDING suffix for boarding bookings
                flightKey = fc
                    ? `${fc.carrierCode}${fc.flightNumber}_${fc.origin}_${fc.destination}_${fc.departureDate}`
                    : `${taskFc.flightNumber}_${taskFc.departureAirport}_${taskFc.arrivalAirport}_${taskFc.departureDate}`;
                if (job?.isBoardingBooking || job?.combinedBooking) {
                    flightKey += '_BOARDING';
                }
            }

            // Use the original booking ID as the base — so duplicating from a duplicate
            // still traces back to the original (avoids nested IDs like abc-duplicate-1-duplicate-1)
            // For assigned tasks, strip the _IATA_* suffix to get the original booking ID
            let rawBaseId = job?.originalBoardingBookingId || job._id;
            const baseBookingIdWithoutTaskSuffix = rawBaseId?.includes("_IATA_") ? rawBaseId.split("_IATA_")[0] : rawBaseId;
            const baseBookingId = baseBookingIdWithoutTaskSuffix?.includes("-duplicate-")
                ? baseBookingIdWithoutTaskSuffix.split("-duplicate-")[0]
                : baseBookingIdWithoutTaskSuffix;
            if (
                (job?.isBoardingBooking || job?.combinedBooking || flightKey?.endsWith("_BOARDING")) &&
                baseBookingId?.includes("_BOARDING")
            ) {
                flightKey = baseBookingId;
            }
            // Collect IDs of already-assigned duplicate tasks so the reducer can avoid ID collisions
            const assignedDuplicateIds = Array.isFullArray(taskList)
                ? taskList
                    .filter(task => task?._id?.includes("-duplicate-") && task?._id?.startsWith(baseBookingId))
                    .map(task => task._id)
                : [];

            // When duplicating from an assigned task or a client duplicate, use the original booking
            // from bookingsByFlight instead of the task object (which has task-specific fields stripped
            // and may be missing flightConfirmationDetails)
            let bookingToDuplicate = job;
            if (job?.assignedTime || job?.isClientDuplicate) {
                const flightBookings = bookingsByFlightDict[flightKey] || [];
                const originalBooking = flightBookings.find(b =>
                    b._id === baseBookingId && !b.isClientDuplicate
                );
                if (originalBooking) {
                    bookingToDuplicate = originalBooking;
                }
            }

            // Duplicate locally — the reducer handles all counting from a single source of truth
            dispatch(duplicateBookingLocally({
                booking: bookingToDuplicate,
                flightKey: flightKey,
                assignedDuplicateIds,
                baseBookingId
            }));

            // Show success toast
            dispatch(setToast({
                message: "Boarding/Ramp task duplicated successfully",
                statusType: "success",
            }));
            dispatch(setShowToast(true));
            handleCancel();
            return;
        } else {

            // For regular bookings and assigned tasks, use backend endpoint
            let bookingId = null;

            if (job?.assignedTime) {
                // If it's an assigned task
                if (job?.flightBooking) {
                    // Arrival task - use originalBookingId
                    bookingId = job?.originalBookingId;
                } else {
                    // Departure task - extract booking ID from task ID
                    const jobId = job._id?.split("_IATA")[0];
                    if (!jobId) {
                        console.log("Cannot find job ID", job);
                        dispatch(setToast({
                            message: "Cannot duplicate: Invalid job ID",
                            statusType: "error",
                        }));
                        dispatch(setShowToast(true));
                        return;
                    }
                    bookingId = jobId;
                }
            } else {
                // Regular unassigned booking
                if (job?.originalBookingDoc && job?.flightBooking) {
                    // arrival booking
                    bookingId = job?.originalBookingDoc?._id || job?.originalBookingDoc;
                } else {
                    // Departure booking or other
                    bookingId = job?._id;
                }
            }

            // Validate bookingId
            if (!bookingId) {
                console.log("Cannot find booking ID", job);
                dispatch(setToast({
                    message: "Cannot duplicate: Missing booking ID",
                    statusType: "error",
                }));
                dispatch(setShowToast(true));
                return;
            }

            // Call the backend endpoint for regular bookings
            // iata lets the reducer spot an arrival: SITA/Connect bookings have no iata field
            dispatch(duplicateTaskAction({ bookingId, iata: dbUser.details.authority }));

        }
    };

    const handleMovePax = () => {
        const payload = {
            passenger: job,
            show: true
        }
        dispatch(setChangeLocModal(payload));
        handleCancel()
    }

    const handleToggleCheckInPause = () => {
        const bookingId = job?.originalBookingId || job?._id;
        if (!bookingId) return;
        const action = isCheckInPaused ? 'resume' : 'pause';
        lastPauseActionRef.current = action;
        dispatch(toggleCheckInPause({
            bookingId,
            action,
            setBy: {
                id: firebaseUser?.uid ?? "",
                name: firebaseUser?.displayName ?? "",
                email: firebaseUser?.email ?? "",
            },
            iata: dbUser.details.authority,
        }));
    };

    const cancelRCSession = async (bookingId) => {
        try {
            const token = await getToken();
            await fetch('/api/v1/remotecheckin/portal-cancel', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'firebase-uid': token },
                body: JSON.stringify({ bookingId }),
            });
        } catch (e) {
            console.error('[RC] portal cancel failed (non-fatal)', e);
        }
    };

    const handleRemoveFromLoc = () => {
        const confirmed = window.confirm(`Are you sure you want to remove this passenger from this location?`);

        if (confirmed) {
            if (job?.flightConfirmationDetails?.origin === dbUser.details.authority) {
                const paxLocation = {
                    bookingId: job?.originalBookingId ? job?.originalBookingId : job?._id,
                    activity: "manually-removed",
                    location: "manually-removed",
                    locationTitle: "manually-removed",
                    time: new Date(),
                    checkInFlag: false,
                    setBy: {
                        id: firebaseUser?.uid ?? "",
                        name: firebaseUser?.displayName ?? "",
                        from: "portal",
                        time: new Date(),
                    }
                }
                dispatch(setBookingLocation(paxLocation))
            } else {
                dispatch(arrivalPaxCheckIn({
                    bookingId: job?.originalBookingId ? job?.originalBookingId : job?._id,
                    body: {
                        type: "manually-removed",
                        iata: dbUser.details.authority,
                        setBy: {
                            id: firebaseUser?.uid ?? "",
                            name: firebaseUser?.displayName ?? "",
                            from: "portal",
                            time: new Date(),
                        }
                    }
                }));
            }
            if (job?.paxManualCheckIn) {
                cancelRCSession(job?.originalBookingId ?? job?._id);
            }
        }
    }

    const handleCheckOut = () => {
        const paxLocation = {
            bookingId: job?.originalBookingId ? job?.originalBookingId : job?._id,
            activity: "Check-out",
            location: "Check-out",
            locationTitle: "Check-out",
            time: new Date(),
            checkInFlag: false,
            setBy: {
                id: firebaseUser?.uid ?? "",
                name: firebaseUser?.displayName ?? "",
                from: "portal",
                time: new Date(),
            }
        }
        dispatch(setBookingLocation(paxLocation))
        if (job?.paxManualCheckIn) {
            cancelRCSession(job?.originalBookingId ?? job?._id);
        }
    }


    //#endregion
    return (
        <div>
            <MenuList>
                {/* At Loc */}
                {canAtLoc && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "At Loc" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("At Loc")} onMouseLeave={() => setHover('none')} color={hover === "At Loc" ? 'white' : 'gray'} onClick={handleAtLoc}>
                        {(updateTaskStatus === "loading" && hover === "At Loc") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <MdLocationPin size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"At Loc"}
                    </StyledParagraph>
                </div>}

                {/*Start Task */}
                {canStartTask && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Start Task" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Start Task")} onMouseLeave={() => { setHover('none') }} color={hover == "Start Task" ? 'white' : 'gray'} onClick={handleStartTask}>
                        {(updateTaskStatus === "loading" && hover === "Start Task") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <FaCheck size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Start Task"}
                    </StyledParagraph>
                </div>}

                {/*Show Pax List */}
                {/* {canShowPaxList && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Show Pax List" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Show Pax List")} onMouseLeave={() => { setHover('none') }} color={hover == "Show Pax List" ? 'white' : 'gray'} onClick={handleShowPaxList}>
                        {(updateTaskStatus === "loading" && hover === "Show Pax List") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <FaCheck size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Show Pax List"}
                    </StyledParagraph>
                </div>} */}

                {/*Complete Task */}
                {canCompleteTask && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Complete Task" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Complete Task")} onMouseLeave={() => { setHover('none') }} color={hover == "Complete Task" ? 'white' : 'gray'} onClick={handleCompleteTask}>
                        {(updateTaskStatus === "loading" && hover === "Complete Task") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <FaCheckDouble size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Complete Task"}
                    </StyledParagraph>
                </div>}

                {/* Stop Task */}
                {canStopTask && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Stop Task" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Stop Task")} onMouseLeave={() => { setHover('none') }} color={hover == "Stop Task" ? 'white' : 'gray'} onClick={handleStopTask}>
                        {(updateTaskStatus === "loading" && hover === "Stop Task") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <AiOutlineStop size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Stop Task"}
                    </StyledParagraph>
                </div>}
                {/* No Show */}
                {canNoShow && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "No Show" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("No Show")} onMouseLeave={() => { setHover('none') }} color={hover == "No Show" ? 'white' : 'gray'} onClick={handleNoShow}>
                        {updateBookingStatus === "loading" ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <MdPersonOff size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"No Show"}
                    </StyledParagraph>
                </div>}
                {/*ReSend notification */}
                {canSendNotify && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Send Notification" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Send Notification")} onMouseLeave={() => { setHover('none') }} color={hover == "Send Notification" ? 'white' : 'gray'} onClick={handleSendNotification}>
                        {(sendNotificationStatus === "loading" && hover === "Send Notification") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <IoNotificationsOutline size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Send Notification"}
                    </StyledParagraph>
                </div>}


                {/*duplicate booking to assign to two employees */}
                {canDuplicate && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Duplicate" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Duplicate")} onMouseLeave={() => { setHover('none') }} color={hover == "Duplicate" ? 'white' : 'gray'} onClick={handleDuplicate}>
                        {duplicateStatus === "loading" ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <HiOutlineDuplicate size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Duplicate"}
                    </StyledParagraph>
                </div>}

                {/*pax check out */}
                {canCheckOut && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Check Out" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Check Out")} onMouseLeave={() => { setHover('none') }} color={hover == "Check Out" ? 'white' : 'gray'} onClick={handleCheckOut}>
                        {setBookingLocationStatus === "loading" ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <BiUserX size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Check Out"}
                    </StyledParagraph>
                </div>}
                {/*pax check in */}
                {canCheckIn && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Check In" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Check In")} onMouseLeave={() => { setHover('none') }} color={hover == "Check In" ? 'white' : 'gray'} onClick={handleCheckIn}>
                        <BiUserCheck size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Check In"}
                    </StyledParagraph>
                </div>}
                {/*pax unReject */}
                {canUnReject && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "unReject" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("unReject")} onMouseLeave={() => { setHover('none') }} color={hover == "unReject" ? 'white' : 'gray'} onClick={handleUnRejectPax}>

                        {unRejectPaxStatus === "loading" ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <BiUserCheck size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"unReject"}
                    </StyledParagraph>
                </div>}

                {/*QR code assign */}
                {canAssign && dbUser?.details?.authority != 'JER' && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Assign" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Assign")} onMouseLeave={() => { setHover('none') }} color={hover == "Assign" ? 'white' : 'gray'} onClick={handleScannerClick}>
                        <MdQrCode2 size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Assign"}
                    </StyledParagraph>
                </div>}
                {/* Unplan Task */}
                {canUnPlan && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Unplan" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Unplan")} onMouseLeave={() => { setHover('none') }} color={hover == "Unplan" ? 'white' : 'gray'} onClick={handleUnplanTask} style={{ flex: 1, display: 'flex' }}>
                        <div style={{ flex: 2 }}>
                            {deleteTaskStatus === "loading" ?
                                <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} />
                                :
                                <MdDeleteOutline size={20} style={{ marginInlineEnd: "5px" }} />
                            }
                        </div>
                        <div style={{ flex: 10 }}>
                            {"Unplan"}
                        </div>
                    </StyledParagraph>
                </div>}
                {/* Edit Task */}
                {canEdit && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Edit" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Edit")} onMouseLeave={() => { setHover('none') }} color={hover == "Edit" ? 'white' : 'gray'} onClick={handleEditTask}>
                        <CiEdit size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Edit"}
                    </StyledParagraph>
                </div>}

                {/* Change Location */}
                {canChangeLoc && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Move" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Move")} onMouseLeave={() => { setHover('none') }} color={hover == "Move" ? 'white' : 'gray'} onClick={handleMovePax}>
                        <RiUserLocationLine size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Change Loc"}
                    </StyledParagraph>
                </div>}
                {/* Remove from Location */}
                {canRemoveFromLoc && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Remove from Location" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Remove from Location")} onMouseLeave={() => { setHover('none') }} color={hover == "Remove from Location" ? 'white' : 'gray'} onClick={handleRemoveFromLoc}>
                        {(setBookingLocationStatus === "loading" || arrivalPaxCheckInStatus === "loading")
                            ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} />
                            : <BiUserX size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Remove from Loc"}
                    </StyledParagraph>
                </div>}

                {/* Pause / Resume Check-in */}
                {canPauseCheckIn && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "PauseCheckIn" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("PauseCheckIn")} onMouseLeave={() => { setHover('none') }} color={hover == "PauseCheckIn" ? 'white' : 'gray'} onClick={handleToggleCheckInPause}>
                        {toggleCheckInPauseStatus === "loading" ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : isCheckInPaused ? <FaPlay size={16} style={{ marginInlineEnd: "5px" }} /> : <FaPause size={16} style={{ marginInlineEnd: "5px" }} />}
                        {isCheckInPaused ? "Resume Check-in" : "Pause Check-in"}
                    </StyledParagraph>
                </div>}

                {/*Delete Booking */}
                {canDeleteBooking && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Delete" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Delete")} onMouseLeave={() => { setHover('none') }} color={hover == "Delete" ? 'white' : 'gray'} onClick={handleShowDeleteBookingModal}>
                        <MdDeleteOutline size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Delete"}
                    </StyledParagraph>
                </div>}
                {/* View Task */}
                {canView && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === 'view' ? Colors.PRM_LIGHT_BLUE : 'white', borderBottomLeftRadius: 5, borderBottomRightRadius: 5, cursor: 'pointer' }}>
                    <StyledParagraph onMouseOver={() => setHover('view')} onMouseLeave={() => { setHover('none') }} color={hover == 'view' ? 'white' : 'grey'} onClick={handleViewTask}>
                        <IoEyeOutline size={20} style={{ marginInlineEnd: "5px" }} />
                        View
                    </StyledParagraph>
                </div>}



            </MenuList>
        </div>
    );
};

export default JobActionMenu;